/* eslint-disable import/prefer-default-export */
export const DEFAULT_OBSERVER_TIMEOUT = 1900;
